/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import styles from './BackNextButtons.module.scss'
import { useHistory } from 'react-router-dom'

const BackNextButtons = ({ props, nextOnClick, displayBack = false }) => {
  const history = useHistory()
  return (
    <div className={styles['display_flex']}>
      {displayBack && (
        <div className={styles['back_center']}>
          <a
            onClick={() => {
              try {
                history.push(props.prevURL)
              } catch (e) {
                console.log(e)
              }
            }}
            href={props.prevURL}
          >
            {props.prevText}
            <span className="ns-visually-hidden">(ouvre dans un nouvel onglet)</span>
          </a>
        </div>
      )}
      <div>
        <button
          disabled={props.isNextDisabled}
          className={['btn-lg btn-default', styles['margin_zero']].join(' ')}
          onClick={nextOnClick}
          value={props.nextText}
          name={props.nextText}
        >
          {props.nextText}
        </button>
      </div>
    </div>
  )
}

export default BackNextButtons
